export default {
  black: "#151515",
  mainColor: "#ED7D31",
  mainRed: "#BB2D1F",
  mainGreen: "#039739",
  mainLightColor: "#6447C9",
  mainLight2Color: "#602895",
  mainDarkColor: "#370D68",
  lightPurple: "#8777FF",
  button: "#FBAA5C",
  bgBlackColor: "#1a1a1a",
  bgColor: "#3B0D69",
  bgLightColor: "#4D157B",
  darkGrey: "#999",
  lightGrey: "#e6e6e6",
  navy: "#1D3548",
  navyDarkGrey: "#2A394B",
  navbar: "#c0392b",
  iconColor: "#3F0000",
};
